<template>
  <div>
    <dx-data-grid ref='refRecalcGrid'
      :data-source='recalcInfoList'
      :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
      :hover-state-enabled = "true" :allowColumnResizing = 'true'
      column-resizing-mode = 'widget' :allow-column-reordering = "true"
      height='250' :row-alternation-enabled="true"
      :focused-row-enabled="true"
      :auto-navigate-to-focused-row="false"
      key-expr="seqId"
      @toolbar-preparing='onToolbarPreparing'
       @init-new-row='onInitNewRow'
      @row-updated="onRowUpdated"
      @row-updating="onRowUpdating"
      @row-inserting="onRowInserting"
      @row-inserted="onRowInserted"
      @row-removing="onRowRemoving"
      @row-removed="onRowRemoved"
    >
      <DxSearchPanel
        :visible="true"
        placeholder="검색..."
      />
      <DxExport
        :enabled="false"
        :file-name="excelFileName"
      />
      <DxFilterRow
        :visible="false"
        apply-filter="auto"
      />
      <DxEditing
        :allow-deleting="true"
        :allow-updating="true"
        :allow-adding="true"
        :use-icons="true"
        mode='row'
      />
      <DxColumn
        :allowEditing='false'
        caption="마감처명"
        data-field="마감처코드"
        :visible='true'
      >
          <DxLookup
          :data-source="customerLookup"
          display-expr="거래처명"
          value-expr="거래처코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="마감월"
        data-field="마감월"
        dataType='date'
        format='yyyy-MM'>
      </DxColumn>
      <DxColumn
        :allowEditing='true'
        caption="정산유형"
        data-field="정산코드"
        :visible='true'
      >
        <DxLookup
          :data-source="recalcTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
        <dx-required-rule message="항목을 선택하세요"/>
      </DxColumn>

      <DxColumn
        :allowEditing='true'
        caption="정산금액"
        data-field="정산금액"
        :visible='true'
        dataType="number"
        format='#,##0'
      >
        <dx-required-rule message="항목을 입력하세요"/>
      </DxColumn>
      <DxColumn
        :allowEditing='true'
        caption="비고"
        data-field="비고"
        :visible='true'
        width="250"
      >
      </DxColumn>

      <DxSummary>
        <DxTotalItem
          value-format='#,##0'
          column="발생일자"
          display-format="{0} (건)"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="정산금액"
          display-format="{0}"
        />
      </DxSummary>
      <dx-paging :enabled="false"/>
      <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
      <dx-sorting mode="multiple"/>
    </dx-data-grid>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxTotalItem, DxLookup, DxEditing,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport } from 'devextreme-vue/data-grid'
import { DxRequiredRule } from 'devextreme-vue/validator'

export default {
  name: 'PurchaseReCalcSubGrid',
  data: function () {
    return {
      userInfo: null,
      recalcInfoList: null,
      itemTypeLookup: null,
      materialTypeLookup: null,
      excelFileName: null,
      customerLookup: null,
      recalcTypeLookup: null
    }
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    baseDate: {
      type: Object,
      default: null
    },
    goodsType: {
      type: String,
      default: ConstDef.자재유형_원자재
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxPaging,
    DxLookup,
    DxExport,
    DxSummary,
    DxTotalItem,
    DxSorting,
    DxSearchPanel,
    DxFilterRow,
    DxEditing,
    DxRequiredRule
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.materialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.customerLookup = this.$store.getters.getCompanyInfo
    this.recalcTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.정산유형)
  },
  mounted () {
    this.refreshReCalcIInfo()
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onInitNewRow (row) {
      row.data.마감월 = this.baseDate.fromDate
      row.data.자재유형 = this.goodsType
      row.data.마감처코드 = this.item.data.거래처코드
    },
    onRowInserting (row) {

    },
    onRowInserted (row) {
      row.data.createTime = row.data.updateTime = AppLib.getNow()
      row.data.createId = row.data.updateId = this.userInfo.userId
      this.$_sp.runInsertAndFindSqlProc('월차감금액', ['마감월', '자재유형', 'createTime', 'createId'], ['seqId'], row.data)
        .then(data => {
          row.data.seqId = this.$_sp.MakeModel(data)[0].seqId
          this.refresnRecalcAmount()
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdating (row) {

    },
    onRowUpdated (row) {
      this.$_sp.runUpdateSqlProc('월차감금액', ['seqId'], null, [row.data])
        .then(data => {
          this.refresnRecalcAmount()
        })
    },
    onRowRemoving (row) {

    },
    onRowRemoved (row) {
      this.$_sp.runDeleteSqlProc('월차감금액', [{ seqId: row.data.seqId }])
        .then(data => {
          this.refresnRecalcAmount()
        })
    },

    onToolbarPreparing (e) {
    },
    refreshReCalcIInfo () {
      const param = {
        마감월: this.baseDate.fromDate,
        자재유형: this.goodsType,
        마감처코드: this.item.data.거래처코드
      }
      this.$_sp.runNoEncodeFindSqlProc('월차감금액', param)
        .then(data => {
          this.recalcInfoList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refresnRecalcAmount () {
      let amount = 0
      this.recalcInfoList.forEach(item => {
        amount += item.정산금액
      })
      this.$emit('refresh-recalc-amount', amount)
    }
  }
}
</script>

<style lang="scss">
.dx-master-detail-cell {
  padding-top: 8px!important;
}
</style>
